import routerView from '@/views/layout/routerView'

export const callRoute = [
  {
    path: 'call',
    name: '呼叫中心',
    icon: 'icon-xiansuo2',
    component: routerView,
    hidden: false,
    children: [
      {
        path: 'callLog',
        name: '通话记录',
        icon: 'icon-xiansuo2',
        hidden: false,
        component: () => import('@/views/call/page/callLog'),
        meta: {
          nextStart: true,
          breadcrumb: ['智能触达', '呼叫中心', '通话记录']
        }
      },
      {
        path: 'phoneManage',
        name: '话机管理',
        hidden: false,
        component: () => import('@/views/call/page/phoneManage'),
        meta: { nextStart: true, breadcrumb: ['智能触达', '呼叫中心', '话机管理'] }
      },
      {
        path: 'seatManage',
        name: '座席管理',
        hidden: false,
        component: () => import('@/views/call/page/seatManage'),
        meta: { nextStart: true, breadcrumb: ['智能触达', '呼叫中心', '座席管理'] }
      },
      {
        path: 'dataStatistics',
        name: '数据统计',
        hidden: false,
        component: () => import('@/views/call/page/outbound'),
        meta: { nextStart: true, breadcrumb: ['智能触达', '呼叫中心', '数据统计'] }
      },
      {
        path: 'outboundDetails',
        name: '详情',
        hidden: true,
        hide: true,
        component: () => import('@/views/call/page/outboundDetails'),
        meta: { nextStart: true, breadcrumb: ['智能触达', '呼叫中心', '详情'], path: '/zxk/reach/call/dataStatistics' }
      }
    // {
    //   path: 'dataStatistics',
    //   component: routerView,
    //   meta: { title: '数据统计' },
    //   children: [
    //     {
    //       path: 'outbound',
    //       component: () => import('@/views/call/page/outbound'),
    //       meta: { title: '外呼数据统计' }
    //     },
    //     {
    //       path: 'outboundDetails',
    //       hide: true,
    //       component: () => import('@/views/call/page/outboundDetails'),
    //       meta: { title: '详情', highMenu: '/call/dataStatistics/outbound' }
    //     },
    //     {
    //       path: 'seats',
    //       component: () => import('@/views/call/page/seats'),
    //       meta: { title: '座席数据统计' }
    //     }
    //   ]
    // }
    ]
  }
]

export default callRoute
